const MuiTextField = {
    defaultProps: {
        variant: 'outlined',
        size: 'medium'
    },
    styleOverrides: {
        root: {
            ["& label"]: {
                top: '-10px',
                ["&.MuiInputLabel-sizeSmall"]: {
                    top: '-7px'
                },
                ["&.MuiInputLabel-shrink"]: {
                    top: 0
                }
            }
        }
    }
};
export { MuiTextField };

//# sourceMappingURL=textfield-overrides.js.map